import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files directly for bundling
import enCommon from "../locales/en/common.json";
import enHome from "../locales/en/home.json";
import enRegistry from "../locales/en/registry.json";
import enValidation from "../locales/en/validation.json";
import enAdmin from "../locales/en/admin.json";

import deCommon from "../locales/de/common.json";
import deHome from "../locales/de/home.json";
import deRegistry from "../locales/de/registry.json";
import deValidation from "../locales/de/validation.json";
import deAdmin from "../locales/de/admin.json";

// Import config constants for use in this file
import { supportedLocales, defaultLocale } from "./config";

// Re-export all config constants for backward compatibility
export {
  supportedLocales,
  type SupportedLocale,
  defaultLocale,
  ogLocales,
  localeLabels,
  isDefaultLocale,
  getLocalizedPath,
} from "./config";

export const resources = {
  en: {
    common: enCommon,
    home: enHome,
    registry: enRegistry,
    validation: enValidation,
    admin: enAdmin,
  },
  de: {
    common: deCommon,
    home: deHome,
    registry: deRegistry,
    validation: deValidation,
    admin: deAdmin,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLocale,
    supportedLngs: supportedLocales,
    defaultNS: "common",
    ns: ["common", "home", "registry", "validation", "admin"],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Don't auto-detect - we'll set language from URL
      order: [],
      caches: [],
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
